export default "__VITE_ASSET__380cabf2__"